export default "__VITE_ASSET__No_TFA1T__"